import {useTranslation} from 'react-i18next';
import * as css from './MapStep.css';
import AreaSVG from '../../../components/areaSVG/AreaSVG';
import {getHalls, getSeatmaps, assignSeatmap, enableSeatmap, updateEvent} from '../../../../redux/event/eventActions';
import InputListSearch from '../../../../component/input/inputList/InputListSearch';
import {useSelector} from 'react-redux';
import setGlobalState from '../../../../redux/setGlobalState';
import {useEffect, useRef, useState} from 'react';
import StepContext from '../stepContext/StepContext';
import StepRight from '../stepRight/StepRight';
import StepLeft from '../StepLeft/StepLeft';
import MyIframe from '../../../../layout/myIframe/MyIframe';
import {useField} from 'formik';
import {generateSVG} from '../../../../functions/generateSVG';
import Btn from '../../../../component/button/btn/Btn';
import ExplainMap from '../explainMap/ExplainMap';
import CheckboxFormik from '../../../../component/checkboxFormik/CheckboxFormik';
import useShow from '../../../../hooks/useShow';

export const onClickMapStep=async (changedValues)=>{
    if(changedValues.map){
        if(changedValues.map.isNew && changedValues.map.smid){
            // NEW-format seatmap: assign the smap library map to this event and
            // flip the buyer-form flag — the legacy hall-clone path (PUT /event
            // with map.eid) is not touched at all
            await assignSeatmap(changedValues.map.smid);
            await enableSeatmap(true);
            const {map, ...rest} = changedValues;
            if(Object.keys(rest).length)
                await updateEvent(rest);
            return;
        }
        await updateEvent(changedValues);
    }
};
export const getTopMap=(value)=>{
    if(!value?.title)
        return '';
    return value.title;
};
function MapStep() {
    const {t} = useTranslation('newEvent');
    const {halls,getHallsXHR,maps,eid}=useSelector(s=>s.event);
    const iframeRef = useRef(null);
    const [{value},,helpers]=useField('map');
    const {open, close, isOpen} = useShow();
    // NEW-format seatmaps (smap library) — shown on top of the legacy halls
    // with a "חדש" badge. Master-only server side → non-masters get [].
    const [seatmaps, setSeatmaps] = useState([]);
    const [smapSearch, setSmapSearch] = useState('');
    useEffect(() => {
        getSeatmaps().then((maps)=>setSeatmaps(maps || []));
    }, []);
    const smapItems = seatmaps
        .filter((m) => m.status !== 0 && (!smapSearch || (m.title || '').includes(smapSearch)))
        .map((m) => ({
            ...m,
            title: m.title || `מפה ${m.smid}`,
            isSmap: true,
            rightChildren: <css.newBadge>חדש ✨</css.newBadge>,
        }));
    const list = [...smapItems, ...halls];

    const getMoreHalls = (fields) => {
        setSmapSearch(fields.search || '');
        if(getHallsXHR === 'SUCCESS'){
            if(fields.offset === 0)
                setGlobalState('event.halls', []);
            getHalls(fields).then((res)=>{setGlobalState('event.halls', res?.halls || []);});
        }
    };
    const openDescription = (action) => {
        helpers.setValue({...value,action});
        open();
    };
    const onClick = (name, key) => {
        const selected = list[key];
        if(selected?.isSmap){
            // a NEW seatmap: no legacy svg/maps preview — its own preview panel
            setGlobalState('event.maps', []);
            helpers.setValue({eid: 0, smid: selected.smid, title: selected.title, capacity: selected.capacity, isNew: true, action: ''});
            close();
            return;
        }
        const selectedHall = selected;
        const updateHall = selectedHall.svg ? selectedHall : {...selectedHall, svg: selectedHall.areaCount > 1 ? generateSVG(selectedHall.design) : null};
        const hallsMap = new Map(maps.map(map => [map.eid, map]));
        hallsMap.delete(updateHall.eid);
        const newMaps = [{...updateHall}];
        for(const [, map] of hallsMap) {
            if(newMaps.length < maps.length) {
                newMaps.push({...map});
            }
        }
        setGlobalState('event.maps', newMaps);
        helpers.setValue({eid:updateHall.eid, title:updateHall.title,action:''});
        close();
    };
    return (
        <StepContext>
            {halls && (
                <css.wrap $hasPop={isOpen}>
                    <StepRight name="map">
                        <InputListSearch onChange={onClick} list={list} text={t('mapText')}
                            onSearch={(value) => getMoreHalls({search: value, limit: 10, offset: 0})}
                            getMoreAction={() => getMoreHalls({search: smapSearch, limit: 10, offset: halls.length})}/>
                        <css.wrapSvg>
                            {maps.map((hall, index) => (
                                <AreaSVG key={index} title={hall.title} seatCount={hall.seatCount} svg={hall.svg} eid={hall.eid} />
                            ))}
                        </css.wrapSvg>
                    </StepRight>
                    {(value.eid && !isOpen) ? <css.wrapContent>
                        <MyIframe iframeRef={iframeRef} display={value.eid && !isOpen}
                            src={`/e/${eid}/tickets/seats?auditorium=${value.eid}`} />
                    </css.wrapContent> : <></>}
                    {(value.isNew && !isOpen) ? <css.wrapContent>
                        <css.newPreview>
                            <css.newBadge>חדש ✨</css.newBadge>
                            <div className="title">{value.title}</div>
                            {value.capacity ? <div className="cap">{Number(value.capacity).toLocaleString('he')} מושבים</div> : null}
                            <div className="note">מפה מהדור החדש — הרוכשים יבחרו מושבים ישירות על המפה בטופס. שיוך הכרטיסים לאזורי המחיר נעשה בהמשך.</div>
                        </css.newPreview>
                    </css.wrapContent> : <></>}
                    {isOpen && <ExplainMap name={'map'} close={close} action={value.action} title={value.action === 'newMap' ? t('explainOnYourMap') : t('explainOnYourErrorMap')} />}
                    <StepLeft name="map">
                        {(value.eid && !isOpen) &&
                            <css.wrapButtons>
                                <Btn className="white" onClick={()=>openDescription('mapError')}>{t('mapError')}</Btn>
                                <CheckboxFormik name={'map.approveMap'} text={t('approveMapText')} color={'black'}/>
                            </css.wrapButtons>}
                        {!isOpen && !value.eid && !value.isNew && <Btn className="white" onClick={()=>openDescription('newMap')}>{t('newMap')}</Btn>}
                    </StepLeft>
                </css.wrap>)}
        </StepContext>);
}
export default MapStep;
